import { UPDATE_STATE_UPDATED_TIME } from './stateUpdatedTime.types';

export const updateStateUpdatedTime = () => ({
  type: UPDATE_STATE_UPDATED_TIME,
});
